<template>
  <div class="level level-bordered">
    <!-- <div class="level-item has-text-centered border-right">
      <div>
        <p class="title is-4">{{ranking}}</p>
        <p class="heading">Ranking</p>
      </div>
    </div> -->
    <div class="level-item has-text-centered border-right level-link" @click="riderClicked">
      <div>
        <p class="title is-6">{{riderName}}</p>
        <p class="heading">Jinete</p>
      </div>
    </div>
    <div class="level-item has-text-centered border-right level-link" @click="lessonClicked">
      <div>
        <p class="title is-6">{{lesson}}</p>
        <p class="heading">Nivel Actual</p>
      </div>
    </div>
    <div class="level-item has-text-centered border-right">
      <div>
        <p class="title is-6" :style="{color:statusColor}">{{statusText}}</p>
        <p class="heading">Nivel de Doma</p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="title is-6" :style="{color:colorScore}">{{score}}</p>
        <p class="heading">Promedio General</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    rider: {
      required: false,
      type: Object
    },
    horse: {
      required: true,
      type: Object
    },
    totalScore: {
      required: false,
      default: 0,
      type: Number
    }
  },
  created () {
    this.calculateStatus()
  },
  data () {
    return {
      statusColor: '#424242',
      statusText: 'S/I'
    }
  },
  computed: {
    ranking () {
      return 'S/I'
    },
    category () {
      return 'S/I'
    },
    lessonId () {
      return this.horse.lesson ? this.horse.lesson.id : null
    },
    lesson () {
      return this.horse.lesson ? this.horse.lesson.name : 'S/I'
    },
    score () {
      return !isNaN(this.totalScore) ? this.totalScore.toFixed(2) + '%' : 'S/I'
    },
    colorScore () {
      return this.totalScore > 60 ? '#23d160' : '#ff3860'
    },
    riderName () {
      return this.rider ? `${this.rider.name} ${this.rider.lastname}` : 'S/I'
    }
  },
  methods: {
    async calculateStatus () {
      if (this.horse.lesson_status) {
        if (this.horse.lesson_status === 'medium') {
          this.statusColor = '#FFC107'
          this.statusText = 'Medio'
        } else if (this.horse.lesson_status === 'high') {
          this.statusColor = '#23d160'
          this.statusText = 'Alto'
        } else if (this.horse.lesson_status === 'low') {
          this.statusColor = '#ff3860'
          this.statusText = 'Bajo'
        } else {
          this.statusColor = '#424242'
          this.statusText = 'S/I'
        }
      }
    },
    riderClicked () {
      this.$emit('rider-clicked', this.rider)
    },
    lessonClicked () {
      this.$emit('lesson-clicked', this.horse ? this.horse.lesson : null)
    }
  }
}
</script>

<style scoped>
  .border-right{
    border-right: 3px solid #FF9800;
  }

  .level-link{
    cursor: pointer;
  }
</style>
